<div class="main-content">
  <app-mtn-loader></app-mtn-loader>
  <p-toast position="top-right" [autoZIndex]="true"  sticky="true"></p-toast>
  <ng-container *ngIf="isRenderApplication">
    <router-outlet></router-outlet>
  </ng-container>
</div>

